import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddDreamFailure,
  AddDreamSuccess,
  EditDreamFailure,
  EditDreamSuccess,
} from '../../Redux/Actions/DreammanageAction';
import { ADD_DREAM, EDIT_DREAM } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddDreamEpic = action$ =>
  action$.pipe(
    ofType(ADD_DREAM),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addMyDream`, action.payload, { authentication: localStorage.getItem('sessionId') })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.dreamanagement, toast.success(response.response.message));
              return of(AddDreamSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              console.log(response.response);
              return of(AddDreamFailure(response.response));
            }
          }),
        ),
    ),
  );

export const EditDreamEpic = action$ =>
  action$.pipe(
    ofType(EDIT_DREAM),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editDream`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditDreamSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditDreamFailure(response.response));
            }
          }),
        ),
    ),
  );
